export enum PeriodTypeEnum {
	YEAR = 'year',
	QUARTER = 'quarter',
	MONTH = 'month',
}
